@if(isPageRestrictionLoaded) {
<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Timesheet</h1>
            @if(!isReadOnly) {
            <div class="action">
                <ppl-button label="Add New Time entry" icon="fa fa-plus" [customClass]="'primary-button'"
                    [iconPosition]="'left'" (handleClick)="onNewTimesheet()"
                    [authorizeButton]="[pageId, 'AddNewTimeEntry']"></ppl-button>
            </div>
            }
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-timesheet-filter (searchEvent)="onSearch($event)" (exportEvent)="onExport($event)" [chequeNumbers]="chequeNumbers" [export]="true" [pageId]="pageId"></ppl-timesheet-filter>
                    <p class="pl-2"> <span class="error-message">*</span> Atleast one out of the following fields should be populated: <b>Participant Name</b>, <b>Participant PPL ID</b>, <b>Provider Name</b>, <b>Provider PPL ID</b>.</p>
                </div>
                <div class="table-style">
                    @if(timesheets && timesheets.length > 0) {
                    <ppl-list-table [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [enableActions]="true" [data]="timesheets" (rowDetailEvent)="rowClicked($event)"
                        (rowDetailEventTs)="onRowActions($event)" [disableSelection]="true" [cols]="cols"
                        (gridAction)="onAction($event)" [gridTitle]="false" [pagination]="true" [loadPage]="true"
                        [customDataLoaded]="true" (onPageLoad)="onPageLoad($event)" [showExpandIcon]="true"
                        [actionButtons]="actionButtons" [showLineItem]="true" [lineItemCols]="lineItemCols"
                        [from]="'timesheet'" [actionsToBeHidden]="actionsToBeHidden"
                        [columnsToBeHidden]="columnsToBeHidden" [onViewUser]="onViewUserClicked">
                        <ng-template #rowActions let-rowData="rowData">
                            @if (rowData.timeOff && rowData.timeOff > 0) {
                            <ppl-button
                                size="small"
                                [label]="'Timeoff (' + rowData.timeOff + ')'"
                                icon="fa fa-eye"
                                [customClass]="'ghost-button'"
                                [iconPosition]="'left'"
                                (click)="onViewTimeOff(rowData)">
                            </ppl-button>
                            }
                        </ng-template>
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>
}


<div class="filter-panel">
    <ng-template #timesheetDialog let-cancel="cancel">
        <ppl-timesheets-add-entries [entryPage]="'timesheets'"
            (timesheetAdded)="timesheetAdded($event)"></ppl-timesheets-add-entries>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #timesheetViewDialog let-cancel="cancel">
        <ppl-timesheet-detail-view [rowData]="selectedRowData" [lineItem]="selectedLineItem"
            (onProcessComplete)="onProcessComplete($event)" [isReadOnly]="isReadOnly"></ppl-timesheet-detail-view>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #timeoffViewDialog let-cancel="cancel">
        <ppl-timesheet-detail-view [timeoffData]="timeOffData" [isTimeOff]="true" [rowData]="selectedLineItem"
            (onProcessComplete)="onProcessComplete($event)" [isReadOnly]="isReadOnly"></ppl-timesheet-detail-view>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #pdfDialog let-cancel="cancel">
        <div class="" *ngIf="pdfConfig && pdfFile">
            <ppl-editpdf (fieldsUpdated)="fieldsUpdated($event)" [readonly]="true" [pdfConfig]="pdfConfig"
                [signature]="" [pdfBlob]="pdfBlob" [pdfFile]="pdfFile" [signatureId]=""
                [isParticipantFlow]="isParticipantFlow" [selectedParticipantId]="selectedLead"
                [isSelf]="true"></ppl-editpdf>
        </div>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #confirmationDialog let-cancel="cancel">
        <p> Atleast one out of the following fields should be populated: Participant Name, Participant PPL ID, Provider Name, Provider PPL ID</p>
    </ng-template>
</div>
